import React, { useEffect, useState } from 'react';
import MemberDirectory from './MemberDirectory';
import MemberWorkspace from './MemberWorkspace';

const AdminMembers = ({ openMember, onConsumed }) => {
  const [target, setTarget] = useState(openMember || null);
  useEffect(() => { if (openMember?.id) { setTarget(openMember); onConsumed?.(); } }, [openMember]);
  if (target?.id) return <MemberWorkspace key={target.id} memberId={target.id} initialTab={target.tab || 'overview'} onBack={() => setTarget(null)} onDeleted={() => setTarget(null)} />;
  return <MemberDirectory onOpen={(id) => setTarget({ id })} />;
};

export default AdminMembers;
